import {
    CartImpressionTrackingInfo,
    CartImpressionTrackingInfoItem
} from "@omni/types/components/tracking/tracking-info/impression/cartImpression.trackingInfo";
import { ModelMapper } from "@omni/types/utils/modelMapper";

import { OrderDetailsModel } from "@/redux/modules/api/data/orderDetail/@types/orderDetails.model";
import { OrderItemModel } from "@/redux/modules/api/data/orderDetail/@types/orderItem.model";

const warrantyProductInfo = {
    name: "Waarborg pallet",
    analytics: {
        productTitle: "Waarborg pallet",
        superCategoryCode: "waarborg",
        superCategoryName: "Waarborg"
    }
};

const toOrderImpression: ModelMapper<
    { order: OrderDetailsModel; name: string },
    CartImpressionTrackingInfo
> = ({ order, name }) => {
    const setWarranty = (item: OrderItemModel) => {
        if (item.warrantyDeposit) {
            item.title = item.title || warrantyProductInfo.name;
            item.analytics = item.analytics || warrantyProductInfo.analytics;
        }
        return item;
    };
    const cartItems = (order.items || [])
        .map(setWarranty)
        .filter((item) => item.hasProduct);

    return {
        name,
        email: order.customer.email,
        totalPrice: order.totalPrice,
        promotions: order.promotions,
        globalDiscounts: order.globalDiscounts,
        deliveryCost: order.deliveryCost,
        orderId: order.orderId,
        payments: order.payments,
        items: cartItems.map(
            (
                item: OrderItemModel,
                index: number
            ): CartImpressionTrackingInfoItem => {
                const { productTitle = "", superCategoryCode = "" } =
                    item.analytics || {};
                const reduction = item.strikethroughPrice
                    ? item.strikethroughPrice - item.totalPrice
                    : 0;

                return {
                    name: productTitle || item.title || "",
                    id: item.sku,
                    ean: item.ean,
                    category: superCategoryCode,
                    price: item.totalPrice,
                    unitPrice: item.unitPrice,
                    tax: "21%",
                    reduction: reduction,
                    currencyCode: "EUR",
                    quantity: item.quantity,
                    url: item.url,
                    placement: index + 1,
                    brand: item.brandName || ""
                };
            }
        )
    };
};

export { toOrderImpression as getOrderDetailsImpressionTrackingInfo };
